import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/pro-solid-svg-icons";
import React from "react";
import { cn } from "../../../../lib/utils";

const Section = ({ name, icon, setIsOpen, componentName, isOpenState,subtitle }) => {
    return (
        <div
            className="flex justify-between border-b border-gray-300 py-2 px-4 cursor-pointer"
            onClick={() => setIsOpen(componentName)}
        >
            <div className="flex items-center gap-4">
                <FontAwesomeIcon className="text-primary" icon={icon} />
                <div className='flex flex-col gap-2'>
                    <p className="text-primary uppercase text-sm">{name}</p>
                    {subtitle && (<p className='capitalize text-gray-700 text-xs'>{subtitle}</p>)}
                </div>
            </div>
            <FontAwesomeIcon
                className={cn("text-primary transition-all", {
                    ["rotate-180"]: isOpenState[componentName].isOpen,
                })}
                icon={faCaretDown}
            />
        </div>
    );
};

export default Section;
